<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="200"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_fifteenData'"
    :sqOptions="[ 16, 43]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesFifteen',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 79)
      } else if (value === 2) {
        this.$emit('handleProgress', 82)
      } else if (value === 3) {
        this.$emit('handleProgress', 78)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
